import { IJadwalChangesInfo } from "../hooks/use-jadwal-changes";

export const convertScheduleToTimezone = (
  schedule: IJadwalChangesInfo["schedule"],
  timeZone?: string
): IJadwalChangesInfo["schedule"] => {
  return schedule.map(
    ({ end_time, old_end_time, old_start_time, start_time }) => ({
      end_time: new Intl.DateTimeFormat("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone
      }).format(new Date(end_time)),
      old_end_time: new Intl.DateTimeFormat("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone
      }).format(new Date(old_end_time)),
      old_start_time: new Intl.DateTimeFormat("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone
      }).format(new Date(old_start_time)),
      start_time: new Intl.DateTimeFormat("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone
      }).format(new Date(start_time))
    })
  );
};
